import React from 'react';

function icon() {
	const icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="24"
			height="24"
		>
			<rect x="2" y="2" width="20" height="20" rx="3" fill="#008080" />
			<rect x="5" y="8" width="14" height="8" rx="1" fill="white" />
			<path
				d="M10 12 L14 12 M12 10 L14 12 L12 14"
				stroke="#008080"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</svg>
	);
	return icon;
}

export default icon;
